/**
 * Location Picker — Multi-country, multi-governorate
 * Portal pattern: modal moves to <body> to escape header stacking context
 */
(function(){
  var R = window.__JOCELL_REGIONS;
  if (!R) return;

  var LANG = document.documentElement.lang === 'ar' ? 'ar' : 'en';
  var saved = { country: 'iq', gov: '' };
  try {
    saved.gov = localStorage.getItem('jc_gov') || '';
    // Drop any governorate saved by the Jordan store / an older theme
    if (localStorage.getItem('jc_country') !== 'iq' || !R.getGov('iq', saved.gov)) saved.gov = '';
  } catch(e) {}

  function renderGovs(container, cc) {
    var c = R.getCountry(cc);
    if (!c) return;
    var html = '<div class="loc-gov-grid">';
    Object.keys(c.governorates).forEach(function(code){
      var g = c.governorates[code];
      var active = (saved.country === cc && saved.gov === code) ? ' loc-gov--active' : '';
      /* Delivery fee intentionally hidden in the location selector — only delivery time is shown. */
      html += '<button type="button" class="loc-gov' + active + '" data-gov="' + code + '" data-country="' + cc + '">' +
        '<span class="loc-gov-name">' + g['name_' + LANG] + '</span>' +
        '<span class="loc-gov-meta">' + g.hours_min + '-' + g.hours_max + ' ' + (LANG==='ar'?'ساعة':'hours') +
        '</span></button>';
    });
    html += '</div>';
    container.innerHTML = html;
  }

  /* ─── Delivery fee ───
     Iraq: one flat fee (5,000 IQD) for every governorate, free when the viewed product
     price OR the cart total reaches the free-shipping threshold. Both values
     come from theme settings via data-* attributes on the [data-loc-fee]
     element (snippets/sidebar-delivery-card.liquid).
     Elements without those attributes: regions-data.js fee. */
  var liveCartTotal = null; // cents, refreshed from /cart.js

  function num(v){ var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function fmtIQD(v){ return Math.round(v).toLocaleString('en-US') + ' ' + (LANG==='ar' ? 'د.ع' : 'IQD'); }
  function freeLabel(){ return LANG==='ar' ? 'مجاني' : 'Free'; }

  function currentItemPrice(el){
    // Selected variant price (cents) if the product form changed variant, else the server value.
    try {
      var pj = window.productJSON;
      var idInput = document.querySelector('[data-product-form] input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      if (pj && pj.variants && idInput && idInput.value) {
        for (var i = 0; i < pj.variants.length; i++) {
          if (String(pj.variants[i].id) === String(idInput.value)) return num(pj.variants[i].price);
        }
      }
    } catch(e) {}
    return num(el.getAttribute('data-item-price'));
  }

  function legacyFee(g, c){
    return g.fee > 0 ? fmtIQD(g.fee) : freeLabel();
  }

  function renderFees(){
    var g = R.getGov(saved.country, saved.gov);
    var c = R.getCountry(saved.country);
    if (!g || !c) return;
    document.querySelectorAll('[data-loc-fee]').forEach(function(el){
      if (!el.hasAttribute('data-flat-fee')) {
        el.textContent = legacyFee(g, c);
        return;
      }
      var flat = num(el.getAttribute('data-flat-fee'));
      var threshold = num(el.getAttribute('data-free-threshold'));
      var item = currentItemPrice(el) / 100;
      var cartTotal = (liveCartTotal !== null ? liveCartTotal : num(el.getAttribute('data-cart-total'))) / 100;
      var isFree = flat <= 0 || (threshold > 0 && (item >= threshold || cartTotal >= threshold));
      el.textContent = isFree ? freeLabel() : fmtIQD(flat);
      el.classList.toggle('sdc-row-value--free', isFree);
    });
  }

  function refreshCart(){
    if (!document.querySelector('[data-loc-fee][data-flat-fee]') || !window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ if (cart && typeof cart.total_price === 'number') { liveCartTotal = cart.total_price; renderFees(); } })
      .catch(function(){});
  }

  function updateAll() {
    var g = R.getGov(saved.country, saved.gov);
    var c = R.getCountry(saved.country);
    if (!g || !c) return;

    var name = c.flag + ' ' + g['name_' + LANG];
    document.querySelectorAll('[data-loc-display]').forEach(function(el){ el.textContent = name; });

    var eta = '🚚 ' + (LANG==='ar'
      ? ('توصيل خلال ' + g.hours_min + '-' + g.hours_max + ' ساعة')
      : ('Delivery within ' + g.hours_min + '-' + g.hours_max + ' hours'));
    document.querySelectorAll('[data-loc-eta]').forEach(function(el){ el.textContent = eta; });

    renderFees();

    /* BUGFIX: the PDP "pb-delivery" block (governorate name + delivery ETA)
       reads from a completely different attribute set ([data-detected-governorate],
       .pb-delivery-value / [data-delivery-value]) that this picker never wrote to,
       so changing the governorate here never updated it. Bridge it directly here
       using the same governorate data already resolved above. */
    document.querySelectorAll('[data-detected-governorate]').forEach(function(el){ el.textContent = g['name_' + LANG]; });
    document.querySelectorAll('.pb-delivery-value, [data-delivery-value]').forEach(function(el){ el.textContent = eta; });

    window.dispatchEvent(new CustomEvent('location:changed', {
      detail: { country: saved.country, gov: saved.gov, data: g, countryData: c }
    }));
  }

  /* Re-evaluate the fee when the variant or the cart changes */
  document.addEventListener('change', function(e){
    var f = e.target && e.target.closest && e.target.closest('form');
    if (f && (f.hasAttribute('data-product-form') || (f.getAttribute('action') || '').indexOf('/cart/add') >= 0)) {
      setTimeout(renderFees, 50);
    }
  });
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:added', 'product:added-to-cart'].forEach(function(evt){
    document.addEventListener(evt, refreshCart);
    window.addEventListener(evt, refreshCart);
  });
  window.addEventListener('pageshow', refreshCart);

  /* ─── Create a SINGLE shared modal appended to <body> ─── */
  var modal = document.querySelector('[data-loc-modal]');
  if (modal) {
    // Move the FIRST modal found to <body> (portal)
    document.body.appendChild(modal);
    modal.setAttribute('data-loc-portal', 'true');

    // Remove duplicate modals from other pickers (PDP, cart)
    document.querySelectorAll('[data-loc-modal]:not([data-loc-portal])').forEach(function(m){
      m.remove();
    });

    var govsEl = modal.querySelector('[data-loc-govs]');
    var tabs = modal.querySelectorAll('[data-country]');
    var closeBtns = modal.querySelectorAll('[data-loc-close]');

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      renderGovs(govsEl, 'iq');
      tabs.forEach(function(t){ t.classList.toggle('loc-tab--active', t.dataset.country === 'iq'); });
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    // Close buttons
    closeBtns.forEach(function(b){ b.addEventListener('click', closeModal); });

    // Country tabs
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(e){
        e.stopPropagation();
        saved.country = tab.dataset.country;
        saved.gov = '';
        try { localStorage.setItem('jc_country', saved.country); localStorage.removeItem('jc_gov'); } catch(err) {}
        tabs.forEach(function(t){ t.classList.toggle('loc-tab--active', t.dataset.country === saved.country); });
        renderGovs(govsEl, saved.country);
      });
    });

    // Gov selection
    govsEl.addEventListener('click', function(e){
      var btn = e.target.closest('[data-gov]');
      if (!btn) return;
      saved.country = btn.dataset.country;
      saved.gov = btn.dataset.gov;
      try { localStorage.setItem('jc_country', saved.country); localStorage.setItem('jc_gov', saved.gov); } catch(err) {}
      closeModal();
      updateAll();
    });

    // Wire ALL triggers (header, PDP, cart) to open this single modal
    document.querySelectorAll('[data-loc-trigger]').forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });
  }

  /* Default governorate: Baghdad (Iraq-only store) */
  if (!saved.gov) {
    saved.country = 'iq';
    saved.gov = 'baghdad';
    try {
      localStorage.setItem('jc_country', 'iq');
      localStorage.setItem('jc_gov', 'baghdad');
    } catch(e) {}
  }
  updateAll();
  refreshCart();
})();
